<div class="counterContainer">
  <div class="number" *ngIf="number">
    {{ number }}.
  </div>
  <div class="textContainer" [ngClass]="{'fullWidth': !number}">
    <ng-content></ng-content>
  </div>
</div>
